'use client';
import Link from 'next/link';
import Image from 'next/image';
import { clsx } from 'clsx';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import { SvgArrowMore } from '@/components/icons';
import { dateForFrontend } from '@/utils/dates';
import { API_STATIC_FILES } from '@/utils/constants';
import { PromotionItem } from '@/api/promotions/promotions.types';
import { IWithClassname } from '@/models/common';
import s from './PromotionsCard.module.scss';

interface Props extends IWithClassname {
  card: PromotionItem;
  forSlider?: boolean;
}

const shortDateOpt: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit' };

export const PromotionsCard = ({ card, forSlider, className }: Props) => {
  const imageUrl = `${API_STATIC_FILES}${card.banner}`;

  return forSlider ? (
    <li className={clsx(s.card, className)}>
      <div>
        <span className={s.card__date} onClick={e => e.preventDefault()}>
          {card.date_end
            ? `${dateForFrontend(card.date_start, shortDateOpt)} - ${dateForFrontend(card.date_end, shortDateOpt)}`
            : 'Бессрочная'
          }
        </span>
        <p className={s.card__title} onClick={e => e.preventDefault()}>
          {card.title}
        </p>
      </div>
      <div>
        <div className={s.card__imageWrapper}>
          <Image
            src={imageUrl}
            alt={'Изображение на карточке с новостью'}
            sizes="354px"
            fill
          />
        </div>
        <Link href={`/promotions/${card.slug ?? card.id}`}>
          <ActionButton className={s.card__button} isDivElement>
            Подробнее <SvgArrowMore />
          </ActionButton>
        </Link>
      </div>
    </li>
  ) : (
    <li className={clsx(className)}>
      <Link className={s.card} href={`/promotions/${card.slug ?? card.id}`}>
        <div>
          <span className={s.card__date} onClick={e => e.preventDefault()}>
            {card.date_end
              ? `${dateForFrontend(card.date_start, shortDateOpt)} - ${dateForFrontend(card.date_end, shortDateOpt)}`
              : 'Бессрочная'
            }
          </span>
          <p className={s.card__title} onClick={e => e.preventDefault()}>
            {card.title}
          </p>
        </div>
        <div>
          <div className={s.card__imageWrapper}>
            <Image
              src={imageUrl}
              alt={'Изображение на карточке с новостью'}
              sizes="403px"
              fill
            />
          </div>
          <ActionButton className={s.card__button} isDivElement>
            Подробнее <SvgArrowMore />
          </ActionButton>
        </div>
      </Link>
    </li>
  );
};